import React from 'react'

import _ from 'lodash'
import moment from 'moment'

import dateFormats from '../../../../utilities/dates/dateFormats'

const BkFlowEditDateSelect = props => {
  const {
    initialDate,
    activeDateValue,
    dateField,
    fieldLabel,
    toggleDateEvent
  } = props

  return (
    <div className={_.isEmpty(initialDate) ?
      'bk-flow-edit-stay__date-select disabled ' + dateField
    :
      'bk-flow-edit-stay__date-select ' + dateField
    }
     onClick={() => toggleDateEvent(dateField)}
    >
      <p className="bk-flow-edit-stay__date-select-heading u-remove-margin u-font-bold u-font-small">{ fieldLabel }</p>
      <div className="bk-flow-edit-stay__date-select-field">
        <p className="u-remove-margin u-font-small">
          {moment(activeDateValue).format(dateFormats.editStay)}
        </p>
        <i className="bk-flow-edit-stay__date-select-arrow material-icons">arrow_drop_down</i>
      </div>
    </div>
  )
}

export default BkFlowEditDateSelect



// WEBPACK FOOTER //
// ./src/components/edit/dates/layouts/BkFlowEditDateSelect.js